document.addEventListener('DOMContentLoaded', function () {
  const categoriesMenu = document.querySelector('.categories-menu');
  const categoriesDrawer = document.getElementById('categories-drawer');
  const closeCategoriesDrawer = document.getElementById('close-categories-drawer');
  const categoriesDrawerOverlay = document.getElementById('categories-drawer-overlay');
  const categories = document.querySelectorAll('.categories__item--has-childs');
  const sectionHeader = document.querySelector('.section-header');
  const body = document.querySelector('body');

  function openDrawer() {
    categoriesDrawer.classList.add('categories-drawer--active');
    categoriesDrawerOverlay.style.opacity = '1';
    categoriesDrawerOverlay.style.visibility = 'visible';
    sectionHeader.style.zIndex = '5';
    body.classList.add('overflow-hidden');
  }

  function closeDrawer() {
    categoriesDrawer.classList.remove('categories-drawer--active');
    categoriesDrawerOverlay.style.opacity = '0';
    categoriesDrawerOverlay.style.visibility = 'hidden';
    sectionHeader.style.zIndex = '3';
    body.classList.remove('overflow-hidden');
  }

  categoriesMenu.addEventListener('click', openDrawer);
  closeCategoriesDrawer.addEventListener('click', closeDrawer);
  categoriesDrawerOverlay.addEventListener('click', closeDrawer);

  document.addEventListener('click', function (event) {
    if (!categoriesDrawer.contains(event.target) && !categoriesMenu.contains(event.target)) {
      closeDrawer();
    }
  });

  categories.forEach((category) => {
    const arrows = category.querySelector('.arrows');
    arrows.addEventListener('click', function (event) {
      event.stopPropagation();
      category.classList.toggle('active');
    });
  });
});
